<template>
  <fragment>
    <v-row dense class="mr-5 ml-5" align="center">
      <v-col class="pl-1 pb-0 mt-3">
        <span class="text-h5 font-weight-bold"
          >Olá, {{ userInfo.nome }}!👋</span
        >
      </v-col>
    </v-row>
    <v-row class="pa-5">
      <v-col cols="12" md="3">
        <v-card
          :loading="loadingSale"
          class="style-card"
          style="border-radius: 20px"
        >
          <p class="title-card">Valor Total de Vendas</p>
          <p style="font-size: xx-large; font-weight: bold">{{ valueTotal }}</p>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" style="min-height: 200px">
        <v-card
          :loading="loadingSale"
          class="style-card"
          style="border-radius: 20px"
        >
          <p class="title-card">Comissão Total</p>
          <p style="font-size: xx-large; font-weight: bold">
            {{ commissionTotal }}
          </p>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card
          :loading="loadingSale"
          class="style-card"
          style="border-radius: 20px"
        >
          <p class="title-card">Desconto Total</p>
          <p style="font-size: xx-large; font-weight: bold">
            {{ discountTotal }}
          </p>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card
          :loading="loadingSale"
          class="style-card"
          style="border-radius: 20px"
        >
          <p class="title-card">Quantidade de Vendas Total</p>
          <p style="font-size: xx-large; font-weight: bold">{{ saleTotal }}</p>
        </v-card>
      </v-col>
    </v-row>
    <v-col class="px-4">
      <v-alert
        v-if="hasTermsUnsigned"
        border="left"
        color="orange"
        dense
        prominent
        type="warning"
        icon="mdi-alert-circle-outline"
        style="position: sticky; justify-self: flex-end"
        ><v-row
          @click="$router.push('/termos-afiliados')"
          style="cursor: pointer"
          align="center"
        >
          <v-col class="grow">
            Há termos de aceite pendentes aguardando sua assinatura.
            <strong>Clique aqui para assiná-los!</strong>
          </v-col>
        </v-row></v-alert
      >
    </v-col>
    <v-col class="pa-4">
      <p class="font-weight-bold mb-3" style="font-size: large">
        Vendas por Rede
      </p>
      <v-data-table
        :headers="headers"
        :items="saleByProgram"
        class="table-body"
        no-data-text="Não há registro de rede de afiliados para serem exibidos"
        loading-text="Buscando informações de vendas..."
        item-key="idprograma"
        :items-per-page="10"
        mobile-breakpoint="0"
        :loading="loadingSale"
        :search="search"
        :custom-filter="searchByProgramOrEvent"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Redes por página',
        }"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Busque por uma rede ou evento"
            class="mx-4"
            append-icon="mdi-magnify"
            single-line
            hide-details
            @input="handleSearch"
            :color="$config.dados.corinputs"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <div
            style="
              display: flex;
              justify-content: space-evenly;
              gap: 12px;
              padding-right: 6px;
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="10"
                  width="10"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :disabled="loadingSale || hasTermsUnsigned"
                  @click="changeDialogCoupon(item)"
                >
                  <v-icon>mdi-ticket-percent-outline</v-icon>
                </v-btn>
              </template>
              <span>Cupom de desconto</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="10"
                  width="10"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :disabled="hasTermsUnsigned"
                  @click="linkToCopy(item)"
                >
                  <v-icon>mdi-link-variant</v-icon>
                </v-btn>
              </template>
              <span>Copiar link</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.desconto_afiliado="{ item }">
          {{ formatCurrencyValue(item.desconto_afiliado) || "-" }}
        </template>
        <template v-slot:item.comissao_afiliado="{ item }">
          {{ formatCurrencyValue(item.comissao_afiliado) || "-" }}
        </template>
        <template v-slot:item.total_valor_venda="{ item }">
          {{ formatCurrencyValue(item.total_valor_venda) || "-" }}
        </template>
        <template v-slot:item.status_programa="{ item }">
          <v-chip
            style="align-items: center; justify-content: center"
            :color="item.status_programa == 'ATIVO' ? 'success' : 'error'"
            dark
          >
            {{ item.status_programa === "ATIVO" ? "Ativo" : "Inativo" }}
          </v-chip>
        </template>
      </v-data-table>
    </v-col>
    <v-col class="pa-4">
      <p class="font-weight-bold mb-3">Vendas por Afiliado</p>
      <SalesByAffiliateConsumer />
    </v-col>
    <DialogCoupon />
  </fragment>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import DialogCoupon from "@/components/vendas/AffiliatesProgram/DialogCoupon.vue";
import SalesByAffiliateConsumer from "@/components/relatorios/SalesByAffiliateConsumer.vue";
import _ from "lodash";
export default {
  name: "DashboardAffiliate",
  components: {
    DialogCoupon,
    SalesByAffiliateConsumer,
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Rede",
          value: "nome_programa",
          align: "center",
          sortable: false,
        },
        {
          text: "Eventos",
          value: "descricao_produto",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          value: "status_programa",
          align: "center",
          sortable: false,
        },
        {
          text: "Visualização",
          value: "visualizacao_produto",
          align: "center",
          sortable: false,
        },
        {
          text: "Valor de Venda",
          value: "total_valor_venda",
          align: "center",
          sortable: false,
        },
        {
          text: "Desconto",
          value: "desconto_afiliado",
          align: "center",
          sortable: false,
        },
        {
          text: "Comissão",
          value: "comissao_afiliado",
          align: "center",
          sortable: false,
        },
        { text: "Vendas", value: "vendas", align: "center", sortable: false },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "sale", "terms", "loadingSale"]),
    hasTermsUnsigned() {
      return this.terms.some(term => term.status !== "ATIVO");
    },
    commissionTotal() {
      return this.formatCurrencyValue(this.sale?.TOTAIS?.comissao_afiliado);
    },
    discountTotal() {
      return this.formatCurrencyValue(this.sale?.TOTAIS?.desconto_afiliado);
    },
    valueTotal() {
      return this.formatCurrencyValue(this.sale?.TOTAIS?.total_valor_venda);
    },
    saleTotal() {
      return this.sale?.TOTAIS?.vendas;
    },
    saleByProgram() {
      return this.sale?.PROGRAMAS;
    },
  },
  methods: {
    ...mapActions([
      "fetchSaleByAffiliateId",
      "fetchTerms",
      "showSnackbarSuccess",
      "changeDialogCoupon",
    ]),
    handleSearch: _.debounce(function (event) {
      this.getSales(event);
    }, 500),
    getSales(event) {
      this.fetchSaleByAffiliateId({
        id: this.userInfo.idafiliado,
        pesquisar: event || "",
      });
    },
    formatCurrencyValue(valor) {
      if (typeof valor !== "number") {
        return "";
      }
      const valorFormatado = valor.toFixed(2).replace(".", ",");
      return `R$ ${valorFormatado.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
    },
    searchByProgramOrEvent(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toLowerCase().includes(search.toLowerCase())
      );
    },
    linkToCopy(item) {
      const environment = process.env.NODE_ENV;
      const slug = "afiliado/" + item.slug_programa + "/" + this.userInfo.slug;
      this.showSnackbarSuccess("Link copiado com sucesso!");
      switch (environment) {
        case "development":
          return navigator.clipboard.writeText(
            "https://dev.eleventickets.com/" + slug
          );
        case "homolog":
          return navigator.clipboard.writeText(
            "https://ah.eleventickets.com/" + slug
          );
        case "staging":
          return navigator.clipboard.writeText(
            "https://staging.eleventickets.com/" + slug
          );
        case "production":
          return navigator.clipboard.writeText(
            "https://eleventickets.com/" + slug
          );
      }
    },
  },
  beforeMount() {
    this.getSales();
    this.fetchTerms({ idafiliado: this.userInfo.idafiliado });
  },
};
</script>
<style>
.style-card {
  background-color: #f5f5f5;
  border-radius: 20px;
  height: 100%;
  text-align: center;
  padding: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
.title-card {
  font-size: 1.2rem;
  color: #2d1a4c;
  margin-bottom: 10px;
}

.v-input--hide-details > .v-input__control > .v-input__slot {
  margin-bottom: 2px !important;
}
</style>
